<template>
	<div>
		<Head :title="__('Orders')" />

		<h1 class="mb-8 text-3xl font-bold"> {{ __('Orders') }}</h1>

		<div class="mb-6 flex items-center justify-between">
			<div class="flex flex-col">
				<label class="mb-[10px]" for="cat_filter">Filtrera på kategori</label>
				<select
					v-model="form.category"
					id="cat_filter"
					name="cat_filter"
				>
					<option :value="null" selected="true">Välj kategori</option>

					<optgroup
						v-for="parent in parentCategories"
						:key="parent"
						:label="parent.name"
					>
						<option
							v-for="child in parent.childs"
							:key="child"
							:value="child.id"
						>
							{{ child.name }}
						</option>
					</optgroup>
				</select>
			</div>

			<SearchFilter
				v-model="form.search"
				class="mr-4 w-full max-w-md"
				:hasDropdown="false"
				@reset="reset"
			/>
		</div>

		<div class="overflow-x-auto rounded-md bg-white shadow">
			<table class="w-full whitespace-nowrap">
				<tr class="text-left font-bold">
					<th class="px-6 pb-4 pt-6"> {{ __('Date') }} </th>
					<th class="px-6 pb-4 pt-6"> {{ __('Name') }} </th>
					<th class="px-6 pb-4 pt-6"> {{ __('Phone') }} </th>
					<th class="px-6 pb-4 pt-6"> {{ __('Address') }} </th>
					<th class="px-6 pb-4 pt-6"> {{ __('Zip / Postal Code') }} </th>
					<th class="px-6 pb-4 pt-6"> {{ __('City') }} </th>
					<th class="px-6 pb-4 pt-6"> {{ __('Order no') }} </th>
				</tr>

				<tr v-for="order in orders.data" :key="order.id" class="focus-within:bg-gray-100 hover:bg-gray-100">
					<td class="border-t px-6 py-4">{{ order.created_at.substr(0,10) }}</td>
					<td class="border-t">
						<Link class="flex items-center px-6 py-4" :href="`/orders/${order.id}`" tabindex="-1">
							<div class="flex flex-col items-start focus:text-indigo-500">
								<template v-if="order.client">
									<div>{{ order.client.name }}</div>
									<small class="mt-1 bg-gray-50 text-sm">{{ order.client.email }}</small>
								</template>

								<Icon v-if="order.deleted_at" name="trash" class="ml-2 h-3 w-3 flex-shrink-0 fill-gray-400" />
							</div>
						</Link>
					</td>
					<td class="border-t px-6 py-4">{{ order.phone }}</td>
					<td class="border-t px-6 py-4">{{ order.street_address }}</td>
					<td class="border-t px-6 py-4">{{ order.zip_code }}</td>
					<td class="border-t px-6 py-4">{{ order.city }}</td>
					<td class="border-t px-6 py-4">{{ order.id }}</td>
					<td class="w-px border-t px-6 py-4">
						<div class="flex items-center justify-center">
							<Link class="hover:text-indigo-700 text-indigo-500" :href="`/orders/${order.id}`" tabindex="-1">
								<Icon name="edit" class="h-4 w-4 fill-current" />
							</Link>
						</div>
					</td>
				</tr>

				<tr v-if="orders.length === 0">
					<td class="border-t px-6 py-4" colspan="4">{{ __('No orders found.') }} : </td>
				</tr>
			</table>
		</div>

		<Pagination class="mt-6" :links="orders.links" />
	</div>
</template>

<script>
	import { Head, Link } from '@inertiajs/inertia-vue3'
	import pickBy 		  from 'lodash/pickBy'
	import throttle 	  from 'lodash/throttle'
	import mapValues 	  from 'lodash/mapValues'
	import Icon 		  from '@/Shared/Icon'
	import Layout 		  from '@/Shared/Layout'
	import SearchFilter   from '@/Shared/SearchFilter'
	import Pagination 	  from '@/Shared/Pagination'

	export default {
		components: {
			Head,
			Icon,
			Link,
			SearchFilter,
			Pagination,
		},
		layout: Layout,
		props: {
			filters: Object,
			orders: [Object, Array],
		},
		data() {
			return {
				categories: [],
				form: {
					category: this.filters.category,
					search: this.filters.search,
					trashed: this.filters.trashed,
				}
			}
		},
		computed: {
			parentCategories() {
				const items = []

				this.categories.forEach(item => {
					if (!item.parent_id) {
						items.push(item)
					}
				})

				if (items.length > 0) {
					const childs = this.categories.filter(c => c.parent_id !== null)

					items.forEach(parent => {
						parent['childs'] = childs.filter(c => c.parent_id === parent.id)
						parent.childs.unshift(parent)
					})
				}

				return items
			},
			ChildCategories() {
				return this.categories.filter(c => c.parent_id !== null)
			}
		},
		watch: {
			form: {
				deep: true,
				handler: throttle(function () {
					this.$inertia.get('/orders', pickBy(this.form), { preserveState: true })
				}, 150)
			}
		},
		methods: {
			fetchCategories() {
				fetch('/api/categories?per_page=all').then((response) => response.json()).then(data => {
					this.categories = data.categories

					if (this.form.parent_id) {
						this.selectedParent = this.categories.find((category) => category.id === this.form.parent_id)
					}
				})
			},
			reset() {
				this.form = mapValues(this.form, () => null)
			}
		},
		mounted() {
			this.fetchCategories()
		}
	}
</script>
